import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, LinearProgress } from '@mui/material';
import { bgBlur } from '../../../utils/cssStyles';
import Iconify from '../../../components/iconify';
import AccountPopover from './AccountPopover';
import { useAppContext } from '../../../contexts/AppContext';

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 80;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: '#0f172a' }),
  boxShadow: 'none',
  borderBottom: '1px solid rgba(255,255,255,0.06)',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const { appState } = useAppContext();

  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'rgba(255,255,255,0.7)',
            display: { lg: 'none' },
            '&:hover': { color: '#fff' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1 }}>
          <AccountPopover />
        </Stack>
      </StyledToolbar>
      {appState.isLoading && (
        <LinearProgress
          sx={{
            height: 2,
            backgroundImage: 'linear-gradient(90deg, #00B74F, #4F46E5, #00B74F)',
          }}
        />
      )}
    </StyledRoot>
  );
}
